import { GameConstants } from "./GameConstants";

// audiosprite --e "mp3,ogg" --o ../assets/audio/audiosprite *.mp3
export class AudioManager {

    public static isMuted: boolean;

    public static loopPlayingKey: string;
    
    private static game: Phaser.Game;
    private static audioSprite: Phaser.AudioSprite;

    public static init(game: Phaser.Game): void {

        AudioManager.game = game;

        AudioManager.loopPlayingKey = null;

        AudioManager.audioSprite = AudioManager.game.add.audioSprite("audio-sprite");

        try {
            const audioStateStr = localStorage.getItem(GameConstants.AUDIO_KEY);

            if (audioStateStr !== "" && audioStateStr) {
                AudioManager.isMuted = JSON.parse(audioStateStr) === true;
            } else {
                AudioManager.isMuted = false;
            }
        }
        catch {
            AudioManager.isMuted = false;
        }

        AudioManager.game.sound.mute = AudioManager.isMuted;
    }

    public static mute(fromSettingslayer?: boolean): void {

        AudioManager.isMuted = true;
        AudioManager.game.sound.mute = true;

        try {
            localStorage.setItem(GameConstants.AUDIO_KEY, JSON.stringify(AudioManager.isMuted ));
        }
        catch {

        }
    }

    public static forceMute(): void {
        AudioManager.game.sound.mute = true;
    }

    public static forceUnmute(): void {
        AudioManager.game.sound.mute = false;
    }

    public static unmute(fromSettingslayer?: boolean): void {

        AudioManager.isMuted = false;
        AudioManager.game.sound.mute = false;

        try {
            localStorage.setItem(GameConstants.AUDIO_KEY, JSON.stringify(AudioManager.isMuted ));
        }
        catch {

        }
    }

    public static playSound(key: string, loop?: boolean, volume?: number): void {

        loop = loop || false;

        if (loop) {

            if (AudioManager.loopPlayingKey && (AudioManager.loopPlayingKey !== key)) {
                AudioManager.stopSound(AudioManager.loopPlayingKey, true);
            }

            if (AudioManager.loopPlayingKey !== key) {
                AudioManager.audioSprite.play(key, volume);
                AudioManager.loopPlayingKey = key;
            }

        } else {

            AudioManager.audioSprite.play(key, volume);
        }
    }

    public static stopSound(key: string, loop?: boolean): void {

        if (key === null || typeof key === "undefined") {
            return;
        }

        AudioManager.audioSprite.stop(key);
        
        if (loop) {
            AudioManager.loopPlayingKey = null;
        }
    }

    public static setMusicVolume(volume: number): void {

        AudioManager.audioSprite.sounds[AudioManager.loopPlayingKey].volume = volume;
    }
}
